/* tslint:disable */
/* eslint-disable */
/**
 * Aerscape API
 * Aerscape API documentation (internal).
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { EmissionRecordView } from './EmissionRecordView';
import {
    EmissionRecordViewFromJSON,
    EmissionRecordViewFromJSONTyped,
    EmissionRecordViewToJSON,
    EmissionRecordViewToJSONTyped,
} from './EmissionRecordView';

/**
 * 
 * @export
 * @interface PaginatedEmissionRecordViewList
 */
export interface PaginatedEmissionRecordViewList {
    /**
     * 
     * @type {number}
     * @memberof PaginatedEmissionRecordViewList
     */
    count: number;
    /**
     * 
     * @type {string}
     * @memberof PaginatedEmissionRecordViewList
     */
    next?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PaginatedEmissionRecordViewList
     */
    previous?: string | null;
    /**
     * 
     * @type {Array<EmissionRecordView>}
     * @memberof PaginatedEmissionRecordViewList
     */
    results: Array<EmissionRecordView>;
    /**
     * 
     * @type {number}
     * @memberof PaginatedEmissionRecordViewList
     */
    numPages?: number;
}

/**
 * Check if a given object implements the PaginatedEmissionRecordViewList interface.
 */
export function instanceOfPaginatedEmissionRecordViewList(value: object): value is PaginatedEmissionRecordViewList {
    if (!('count' in value) || value['count'] === undefined) return false;
    if (!('results' in value) || value['results'] === undefined) return false;
    return true;
}

export function PaginatedEmissionRecordViewListFromJSON(json: any): PaginatedEmissionRecordViewList {
    return PaginatedEmissionRecordViewListFromJSONTyped(json, false);
}

export function PaginatedEmissionRecordViewListFromJSONTyped(json: any, ignoreDiscriminator: boolean): PaginatedEmissionRecordViewList {
    if (json == null) {
        return json;
    }
    return {
        
        'count': json['count'],
        'next': json['next'] === undefined ? undefined : json['next'] === null ? null : json['next'],
        'previous': json['previous'] === undefined ? undefined : json['previous'] === null ? null : json['previous'],
        'results': ((json['results'] as Array<any>).map(EmissionRecordViewFromJSON)),
        'numPages': json['num_pages'] == null ? undefined : json['num_pages'],
    };
}

export function PaginatedEmissionRecordViewListToJSON(json: any): PaginatedEmissionRecordViewList {
    return PaginatedEmissionRecordViewListToJSONTyped(json, false);
}

export function PaginatedEmissionRecordViewListToJSONTyped(value?: PaginatedEmissionRecordViewList | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'count': value['count'],
        'next': value['next'],
        'previous': value['previous'],
        'results': ((value['results'] as Array<any>).map(EmissionRecordViewToJSON)),
        'num_pages': value['numPages'],
    };
}

